module.exports = __webpack_public_path__ + "img/cacib.d0d42020.svg";